<template>
  <div class="flex flex-col gap-8">
    <IframeMonday />

    <div class="vx-col w-3/4 sm:w-1/2 mx-auto">
      <CuentaAtras />
    </div>

    <ProcesoActivo />
    
    <ChecklistDocumentos />
	</div>
</template>
<script>
import Steps from '@/components/widgets/Steps.vue'
import CuentaAtras from '@/components/widgets/CuentaAtras.vue'
import FichaAsesor from '@/components/widgets/FichaAsesor.vue'
import IframeMonday from '@/components/widgets/IframeMonday.vue'
import ProcesoActivo from '@/components/widgets/ProcesoActivo.vue'
import ChecklistDocumentos from '@/components/widgets/ChecklistDocumentos.vue'
export default {
  components: {
    Steps,
    CuentaAtras,
    FichaAsesor,
    IframeMonday,
    ProcesoActivo,
    ChecklistDocumentos
  },
  data () {
    return {
      id_client: {}
    }
  },
  created () {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || this.$store.state.AppActiveUser
    this.id_client = this.userInfo.client_id
    this.$store.dispatch('fecthCustomerAddedServicesInmigration', this.userInfo)

    // Carga de DOCUMENTOS
    this.$store.dispatch('fetchVisaRequirementsForAClient', this.id_client)
      .catch(err => {
        this.$vs.loading.close()
        console.error(err)
        if (typeof err.response.data.error === 'string') {
          this.$vs.notify({
            title: 'Error',
            text: `${err.response.data.error}`,
            color: 'warning',
            iconPack: 'feather',
            icon:'icon-x-circle',
            time: 6000
          })
        } else {
          const array_errors = Object.entries(err.response.data.error)
          for (let i = 0; i < array_errors.length; i++) {
            this.$vs.notify({
              title: 'Error',
              text: `${array_errors[i][1][0]}`,
              iconPack: 'feather',
              icon: 'icon-x-circle',
              color: 'warning',
              time: 6000
            })
          }
        }
      })

    this.obj = {
      id_client: this.id_client
    }

    // Carga de MONDAY LINKS
    this.$store.dispatch('fetchMondayLinks', this.obj)
      .then((res) => {
        this.monday_iframe = res.data.monday_iframe
      })
      .catch(err => {
        this.$vs.loading.close()
        console.error(err)
        if (typeof err.response.data.error === 'string') {
          this.$vs.notify({
            title: 'Error',
            text: `${err.response.data.error}`,
            color: 'warning',
            iconPack: 'feather',
            icon:'icon-x-circle',
            time: 6000
          })
        } else {
          const array_errors = Object.entries(err.response.data.error)
          for (let i = 0; i < array_errors.length; i++) {
            this.$vs.notify({
              title: 'Error',
              text: `${array_errors[i][1][0]}`,
              iconPack: 'feather',
              icon: 'icon-x-circle',
              color: 'warning',
              time: 6000
            })
          }
        }
      })
    this.$store.dispatch('fetchVisaStepsForAClient', this.id_client).catch(err => { console.error(err) })
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
.monday-iframe {
  width: 100%;
  height: 900px;
  border-radius: 0.5rem;
  box-shadow: 5px 5px 56px 0px rgba(0,0,0,0.25);
}
.button-alignment {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.name-service-cell-width {
  width: 21em;
}
.visa-type-cell-width {
  width: 12em;
}
.action-cell-width {
  max-width: 5rem;
}
.product-name1 {
  max-width: 8rem;
}
.product-category1 {
  width: 7rem;
}
.product-category {
  width: 7rem;
}
.product-name {
      max-width: 12rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        // .vs-table-text{
        //   text-transform: uppercase;
        //   font-weight: 200;
        // }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
</style>
